import React from 'react';

import { FeatureGuard } from '@components/Guards';

import Messenger from '@views/Messenger/Main';

export default function MessengerPage() {
  return (
    <FeatureGuard feature={'MessengerUseChat'}>
      <Messenger />
    </FeatureGuard>
  );
}
